export const isSecondPageAndCenter = (
  steps,
  doctors,
  department
) => {
  const condition =
    steps === 2 &&
    doctors &&
    doctors?.length !== 0 &&
    department.NobatBaPezeshKYaVahed === 2;

  // console.log('--->', {
  //   steps,
  //   doctors,
  //   department,
  // });

  return condition;
};
